import { BreakpointOptions } from "../../types/theming";
import { ViewportOperand } from "./ViewportOperand";
import {
	ViewportResult,
	ViewportScale,
	ViewportState,
} from "./useViewport.types";

export class ViewportOperator implements ViewportResult {
	private _breakpointSize: BreakpointOptions;
	private _scale: number;

	constructor(breakpointSize: BreakpointOptions) {
		this._breakpointSize = breakpointSize;
		this._scale = ViewportScale[breakpointSize];
	}

	get currentSize(): BreakpointOptions {
		return this._breakpointSize;
	}

	get is(): ViewportState {
		return new ViewportOperand(this._scale, "is");
	}

	get greaterThan(): ViewportState {
		return new ViewportOperand(this._scale, "greaterThan");
	}

	get lessThan(): ViewportState {
		return new ViewportOperand(this._scale, "lessThan");
	}
}
